module.exports = __webpack_public_path__ + "img/zs_02.1cb68c70.png";